import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { clientStore } from 'apps/client/app';

import Button from 'components/Button';
import Heading from 'components/Heading';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { EditorField } from 'libs/forms/views/fieldTypes/editor';

import {
  MarkdownBodyWrapper,
  TitleWrapper,
  SectionTitle,
  ReadmeSection,
  TitleInput,
  ActiveEditorWrapper,
  EditorWrapper,
  SectionButtonGroup,
} from 'apps/readme/styles';
import { ButtonGroup } from 'legacyComponents/styles';

@withNamespaces()
@observer
export class MarkdownBody extends React.Component {
  render() {
    const { readme, isOwner, t, repoManager } = this.props;
    const { sectionApps, editing, uploading } = readme;
    const { CreateSection, DeleteSection } = readme;
    const title = sectionApps.length ? sectionApps[0].title : '...';

    return (
      <MarkdownBodyWrapper>
        {sectionApps.map((section, i) => (
          <ReadmeSection
            key={i}
            data-intercom-target={i === 0 ? 'project-introduction' : ''}
            ref={sectionRef => {
              section.ref = sectionRef;
            }}
            last={i + 1 === sectionApps.length}
          >
            {i === 0 && (
              <TitleWrapper>
                <Heading level='2' size='xmedium'>
                  {title}
                </Heading>
                {isOwner &&
                  !['s', 'xs'].includes(clientStore.activeBreakPoint) && (
                    <ButtonGroup>
                      {!editing && (
                        <>
                          {repoManager.routerStore.route.path.split('/')[1] ===
                            '+opennext' && (
                            <Button
                              disabled={uploading}
                              onClick={() => {
                                repoManager.OpenSubtemplates(null, true);
                              }}
                              size='small'
                              text={<Trans>Edit template sections</Trans>}
                              variant='tertiary'
                              outline
                            />
                          )}
                        </>
                      )}
                    </ButtonGroup>
                  )}
              </TitleWrapper>
            )}
            {i > 0 && !editing && (
              <SectionTitle condition={i > 0 && !editing}>
                <Heading level='3' size='medium'>
                  {section.title}
                </Heading>
              </SectionTitle>
            )}
            {i > 0 && editing && (
              <SectionTitle condition={i > 0 && editing}>
                <TextField
                  fieldStore={section.form.fieldStores.get('title')}
                  placeholder={t('Section Title')}
                  editComponent={TitleInput}
                  validationPosition={{ top: '7px', right: '4px' }}
                  type='text'
                  className='lightBorder'
                />
              </SectionTitle>
            )}
            <EditorField
              fieldStore={section.form.fieldStores.get('body')}
              editComponent={editing ? ActiveEditorWrapper : EditorWrapper}
              validationPosition={{ top: '10px', right: '10px' }}
              type='text'
              className='lightBorder'
              blueBorder
              noFormattingHint
              noValidation
            />
            {editing && (
              <SectionButtonGroup>
                <Button
                  onClick={() => {
                    CreateSection(i);
                  }}
                  size='small'
                  variant='secondary'
                  icon='edit'
                  ariaLabel='Create section'
                  outline
                />
                {sectionApps.length > 1 && (
                  <Button
                    onClick={() => {
                      DeleteSection(i);
                    }}
                    size='small'
                    variant='destructive'
                    outline
                    icon='delete'
                    ariaLabel='Delete section'
                  />
                )}
              </SectionButtonGroup>
            )}
          </ReadmeSection>
        ))}
      </MarkdownBodyWrapper>
    );
  }
}

MarkdownBody.propTypes = {
  readme: PropTypes.object,
  isOwner: PropTypes.bool,
  isLocalChange: PropTypes.bool,
  repository: PropTypes.object,
  t: PropTypes.func,
};
